<script setup lang="ts">
const colorMode = useColorMode()
colorMode.value = 'dark'

const color = computed(() => (colorMode.value === 'dark' ? '#171717' : 'white'))

// Ensure server-rendered HTML contains the `dark` class and set lang
useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [{ rel: 'icon', href: '/favicon.ico' }],
  htmlAttrs: {
    lang: 'en',
    class: 'dark'
  }
})

useSeoMeta({
  twitterImage:
    'https://jarvispropertymaintenance.co.uk/templates/homepage.png',
  twitterCard: 'summary_large_image'
})
</script>

<template>
  <UApp :toaster="{ expand: false }">
    <AppHeader />

    <UMain as="main">
      <NuxtPage />
    </UMain>

    <AppFooter />
    <!-- Make CTA fixed so it doesn't reserve layout space at page bottom -->
    <ClientOnly>
      <AppStickyCta
        class="fixed bottom-[calc(0.5rem+env(safe-area-inset-bottom))] left-1/2 z-100 w-full max-w-3xl -translate-x-1/2 transform px-2"
      />
    </ClientOnly>
  </UApp>
</template>
